module.exports = __webpack_public_path__ + "static/nlp-paper-90eedad47fd66a50b7ad25bb1525f81b.pdf";